/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const JSG = require('../../JSG');
const Node = require('./Node');
const ItemAttributes = require('../attr/ItemAttributes');
const DataProvider = require('./DataProvider');
/**
 * Class that contains the cell area of a worksheet.
 *
 * @class CellsNode
 * @extends Node
 * @constructor
 */
module.exports = class CellsNode extends Node {
	constructor(sheetModel) {
		super();

		this._model = sheetModel;

		this.getFormat().setFillColor(JSG.theme.sheet);
		this.getItemAttributes().setSelectionMode(ItemAttributes.SelectionMode.NONE);
		this.getItemAttributes().setPortMode(ItemAttributes.PortMode.NONE);
	}

	newInstance() {
		return new CellsNode();
	}

	get isCellsNode() {
		return true;
	}
	
	getMinSize() {
		return 0;
	}

	_copy(copiednodes, deep, ids) {
		const copy = super._copy(copiednodes, deep, ids);

		// copy._data = this._data.copy();

		return copy;
	}

	getSheet() {
		return this.getParent() ? this.getParent().getParent() : undefined;
	}

	getItemType() {
		return 'cellsnode';
	}

	saveContent(file, absolute) {
		super.saveContent(file, absolute);

		// this._data.save(file);
	}

	_saveSubItems(file) {
		// do not save subitems, they are saved in machine server
	}

	_assignName(id) {
		this.setName(`Cells${id}`);
	}

	read(reader, object) {
		super.read(reader, object);
		// this._data.clear();
		//
		// reader.iterateObjects(object, (name, child) => {
		// 	switch (name) {
		// 		case 'data':
		// 			this._data.read(reader, child);
		// 			break;
		// 		default:
		// 			break;
		// 	}
		// });
	}
};
